import Lending from './Lending'

export default Lending